import * as e from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var t = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var n = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let ee, te = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, d = 0, f = u.signal ?? new AbortController().signal;
		for (; !f.aborted;) {
			d++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			ee !== void 0 && a.set("Last-Event-ID", ee);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: f
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let te = s.body.pipeThrough(new TextDecoderStream()).getReader(), d = "", ne = () => {
					try {
						te.cancel();
					} catch {}
				};
				f.addEventListener("abort", ne);
				try {
					for (;;) {
						let { done: e, value: t } = await te.read();
						if (e) break;
						d += t, d = d.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = d.split("\n\n");
						d = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) ee = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: ee,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					f.removeEventListener("abort", ne), te.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && d >= o) break;
				let n = Math.min(c * 2 ** (d - 1), s ?? 3e4);
				await te(n);
			}
		}
	}() };
}, r = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, i = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = ({ allowReserved: e, explode: t, name: n, style: a, value: o }) => {
	if (!t) {
		let t = (e ? o : o.map((e) => encodeURIComponent(e))).join(i(a));
		switch (a) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let c = r(a), l = o.map((t) => a === "label" || a === "simple" ? e ? t : encodeURIComponent(t) : s({
		allowReserved: e,
		name: n,
		value: t
	})).join(c);
	return a === "label" || a === "matrix" ? c + l : l;
}, s = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: o }) => {
	if (i instanceof Date) return o ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let c = a(r), l = Object.entries(i).map(([t, i]) => s({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(c);
	return r === "label" || r === "matrix" ? c + l : l;
}, l = /\{[^{}]+\}/g, u = ({ path: e, url: t }) => {
	let n = t, r = t.match(l);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let l = e[i];
		if (l == null) continue;
		if (Array.isArray(l)) {
			n = n.replace(t, o({
				explode: r,
				name: i,
				style: a,
				value: l
			}));
			continue;
		}
		if (typeof l == "object") {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: l,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${s({
				name: i,
				value: l
			})}`);
			continue;
		}
		let u = encodeURIComponent(a === "label" ? `.${l}` : l);
		n = n.replace(t, u);
	}
	return n;
}, ee = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = u({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function te(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var d = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, f = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let l = e[i] || t;
		if (Array.isArray(a)) {
			let e = o({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...l.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = c({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...l.object
			});
			e && r.push(e);
		} else {
			let e = s({
				allowReserved: l.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ne = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, re = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ie = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (re(t, n.name)) continue;
		let e = await d(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, ae = (e) => ee({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : f(e.querySerializer),
	url: e.url
}), oe = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = ce(e.headers, t.headers), n;
}, se = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, ce = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? se(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, le = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ue = () => ({
	error: new le(),
	request: new le(),
	response: new le()
}), de = f({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), fe = { "Content-Type": "application/json" }, pe = (e = {}) => ({
	...t,
	headers: fe,
	parseAs: "auto",
	querySerializer: de,
	...e
}), p = ((e = {}) => {
	let t = oe(pe(), e), r = () => ({ ...t }), i = (e) => (t = oe(t, e), r()), a = ue(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: ce(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ie({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: ae(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: te(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ne(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), ee;
		try {
			ee = JSON.parse(u);
		} catch {}
		let d = ee ?? u, f = d;
		for (let e of a.error.fns) e && (f = await e(d, c, i, t));
		if (f ||= {}, t.throwOnError) throw f;
		return t.responseStyle === "data" ? void 0 : {
			error: f,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: r, url: i } = await o(t);
		return n({
			...r,
			body: r.body,
			headers: r.headers,
			method: e,
			onRequest: async (e, t) => {
				let n = new Request(e, t);
				for (let e of a.request.fns) e && (n = await e(n, r));
				return n;
			},
			serializedBody: te(r),
			url: i
		});
	};
	return {
		buildUrl: (e) => ae({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: r,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: i,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(pe({
	baseUrl: "https://api.myparcel.nl/",
	throwOnError: !0
})), me = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), he = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), ge = e.union([he, e.int()]), _e = e.object({
	status: me.optional(),
	code: ge.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), ve = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: me,
	errors: e.union([e.array(_e), e.record(e.string(), _e)])
}), ye = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." }), be = ve.and(e.object({
	status_code: ye.optional(),
	errors: e.array(e.object({
		status: ye.optional(),
		code: e.int().optional()
	})).optional()
})), m = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), xe = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Se = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ce = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), we = e.string().length(2).regex(/^[A-Za-z]{2}$/), Te = e.union([e.enum([""]), e.unknown()]).nullable(), Ee = e.union([e.unknown(), e.enum([""])]).nullable(), De = e.object({
	account_id: xe.optional(),
	person: e.string().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: we,
	region: e.string().max(35).nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.enum([""])]).nullish(),
	billing_email: Te.optional(),
	secondary_emails: e.array(Ee).nullish(),
	box_number: e.string().max(8).nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Oe = De.and(e.object({
	person: e.unknown().optional(),
	first_name: e.string().max(50).optional(),
	last_name: e.string().max(50).optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), ke = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), Ae = e.object({
	currency: e.enum(["EUR"]),
	amount: e.int().gte(0)
}), je = e.object({ insurance: Ae.optional() }), Me = je.and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), h = e.union([e.literal(0), e.literal(1)]), g = e.object({
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string().regex(/\d*/)])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Ne = e.object({
	age_check: h.optional(),
	cash_on_delivery: g.optional(),
	collect: h.optional(),
	cooled_delivery: h.optional(),
	drop_off_at_postal_point: h.optional(),
	extra_assurance: h.optional(),
	fresh_food: h.optional(),
	frozen: h.optional(),
	hide_sender: h.optional(),
	large_format: h.optional(),
	no_tracking: h.optional(),
	only_recipient: h.optional(),
	priority_delivery: h.optional(),
	receipt_code: h.optional(),
	return: h.optional(),
	same_day_delivery: h.optional(),
	saturday_delivery: h.optional(),
	signature: h.optional(),
	tracked: h.optional()
}), _ = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), Pe = e.object({ package_type: _.optional() }), Fe = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Ie = e.object({ delivery_date: e.string().regex(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/).nullish() }), Le = e.object({ label_description: e.string().max(45).nullish() }), v = Me.and(Ne).and(Pe).and(Fe).and(Ie).and(Le), Re = e.object({
	save_recipient_address: h.optional(),
	delivery_notification: h.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: h.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: h.optional(),
		bcc_email: Te.optional(),
		carrier_email_basic_notification: h.optional(),
		delivery_notification: h.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: h.optional(),
		email_on_handed_to_courier: h.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.union([e.unknown(), e.enum([""])]).optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: h.optional(),
		send_track_trace_emails: h.optional()
	}).optional()
}).nullable(), ze = e.enum([
	"retail",
	"locker",
	"post_office"
]).register(e.globalRegistry, { description: "Pickup / drop-off location type." }), Be = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), Ve = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	location_type: e.union([ze, Be]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), He = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), Ue = e.object({
	description: e.string().max(50),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: g,
	classification: e.string(),
	country: e.union([e.unknown(), e.enum([""])]).optional()
}), y = e.object({
	contents: He,
	invoice: e.string().max(150).nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array(Ue).min(1).max(100)
}), We = e.int().gte(0).lte(999999999), Ge = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ke = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), qe = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Je = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ye = We, Xe = Ge.nullable(), Ze = Ke.nullable(), Qe = qe.nullable(), $e = Je.nullable(), et = e.object({
	weight: We.optional(),
	height: Ge.nullish(),
	width: Ke.nullish(),
	length: qe.nullish(),
	volume: Je.nullish(),
	carrier_weight: e.union([Ye, e.string().regex(/^\d+$/)]).nullish(),
	carrier_height: Xe.nullish(),
	carrier_width: Ze.nullish(),
	carrier_length: Qe.nullish(),
	carrier_volume: $e.nullish()
}).nullable(), tt = e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).nullable(), nt = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), rt = Ve, it = e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }), at = e.union([e.int().gte(0), e.string().regex(/\d*/)]), b = e.object({
	currency: it,
	amount: at.nullable()
}).register(e.globalRegistry, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), ot = e.enum([
	"Facebook",
	"Google",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), st = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), ct = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), x = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), lt = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), ut = lt, dt = e.string().max(255), ft = e.string().max(255).nullable(), pt = m.nullable(), mt = xe, ht = Se, gt = Ce, _t = Oe, vt = De, yt = ke, bt = v.and(e.unknown()), xt = Re, St = Ve, Ct = y.nullable(), wt = et, Tt = tt, Et = nt, Dt = rt, Ot = h, kt = b, At = e.string().max(255), jt = e.union([e.unknown(), e.enum(["Wereld"])]), Mt = ot.nullable(), Nt = st.nullable(), Pt = ct, Ft = x, It = ut, Lt = dt.nullable(), Rt = ft, zt = e.string().max(255), Bt = e.string().max(255), Vt = e.union([e.string().regex(/\d+/), e.int()]), Ht = e.string().max(255), Ut = e.string().max(255), Wt = e.string().max(255), Gt = e.string().regex(/^[A-Z][A-Z]$/), Kt = e.string().max(255), qt = e.string().max(8).nullable(), Jt = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().max(3).nullish(),
	first_name: e.string().max(255).nullish(),
	last_name: e.string().max(255).nullable(),
	email: e.union([e.enum([""]), e.unknown()]).nullable(),
	phone: e.string().max(100).nullable(),
	company: e.string().max(255).nullable(),
	street: zt,
	street_additional_info: Bt.optional(),
	number: Vt,
	number_suffix: Ht.optional(),
	postal_code: Ut,
	city: Wt,
	cc: Gt,
	region: Kt.optional(),
	box_number: qt.optional()
}), Yt = Jt.nullable(), Xt = m.nullable(), Zt = e.string().max(255).nullable(), Qt = Zt, $t = e.boolean().default(!1), en = e.boolean().default(!1), tn = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), nn = e.enum(["", "EUR"]), rn = nn.nullable(), an = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), on = e.union([e.unknown(), e.enum([""])]).nullable(), sn = e.array(e.object({
	uri: e.union([e.enum([""]), e.unknown()]),
	barcode: e.string()
})), cn = sn, ln = e.string().nullable(), un = e.uuid().max(36).nullable(), dn = e.int().nullable(), fn = e.string().nullable(), pn = e.record(e.string(), e.unknown()).nullable(), mn = e.string().nullable(), hn = e.object({
	quantity: dn.optional(),
	order_line_identifier: fn.optional(),
	order_line: pn.optional(),
	picklist_identifier: mn.optional(),
	order_identifier: e.string().nullish()
}).nullable(), gn = e.array(hn).nullable(), _n = e.string().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), vn = _n, yn = vn, bn = _n, xn = bn, Sn = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), Cn = Sn.nullable(), wn = Cn, Tn = Sn.nullable(), En = Tn, Dn = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: m.nullable(),
	account_id: xe,
	shop_id: Se,
	shipment_type: Ce,
	recipient: Oe,
	sender: De,
	status: ke,
	options: v.and(e.unknown()),
	general_settings: Re,
	pickup: Ve,
	customs_declaration: y.nullable(),
	physical_properties: et,
	reference_identifier: tt,
	transaction_status: nt,
	drop_off_point: rt,
	hidden: h,
	price: b,
	barcode: e.string().max(255),
	region: e.union([e.unknown(), e.enum(["Wereld"])]),
	external_provider: ot.nullable(),
	external_provider_id: st.nullable(),
	payment_status: ct,
	carrier_id: x,
	platform_id: ut,
	origin: dt.nullable(),
	user_agent: ft,
	secondary_shipments: e.array(e.object({
		id: m,
		parent_id: pt,
		account_id: mt,
		shop_id: ht,
		shipment_type: gt,
		recipient: _t,
		sender: vt,
		status: yt,
		options: bt,
		general_settings: xt,
		pickup: St,
		customs_declaration: Ct,
		physical_properties: wt,
		reference_identifier: Tt,
		transaction_status: Et,
		drop_off_point: Dt,
		hidden: Ot,
		price: kt,
		barcode: At,
		region: jt,
		external_provider: Mt,
		external_provider_id: Nt,
		payment_status: Pt,
		carrier_id: Ft,
		platform_id: It,
		origin: Lt,
		user_agent: Rt,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: Yt,
		multi_collo_main_shipment_id: Xt,
		external_identifier: Qt,
		delayed: $t,
		delivered: en,
		amount: tn.optional(),
		currency: rn.optional(),
		contract_id: an,
		link_consumer_portal: on.optional(),
		partner_tracktraces: cn.optional(),
		pickup_request_number: ln.optional(),
		order_shipment_identifier: un.optional(),
		shipped_items: gn.optional(),
		created: yn,
		modified: xn,
		created_by: wn,
		modified_by: En
	})),
	collection_contact: Jt.nullable(),
	multi_collo_main_shipment_id: m.nullable(),
	external_identifier: Zt,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: nn.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.enum([""])]).nullish(),
	partner_tracktraces: sn.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(hn).nullish(),
	created: vn,
	modified: bn,
	created_by: Cn,
	modified_by: Tn
}), On = e.object({ data: e.object({ shipments: e.array(Dn).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) }), kn = e.union([e.string(), e.unknown()]), An = e.object({ url: e.url() }), jn = e.object({ data: e.union([
	e.object({ pdf: An }),
	e.object({ pdfs: An }),
	e.object({ csvs: An }),
	e.object({ zpl: An }),
	e.object({ zpls: An })
]) }), Mn = e.array(e.object({
	shipment_id: m,
	price: g,
	price_after_vat: g
})), Nn = e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: Mn,
	blocked_shipments: Mn
}) }) }), Pn = e.object({
	amount: e.int().nullable(),
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Fn = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Pn,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
}), In = e.object({ data: e.object({ payment_instructions: e.array(Fn) }) }), Ln = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." }), Rn = ve.and(e.object({
	status_code: Ln.optional(),
	errors: e.array(e.object({
		status: Ln.optional(),
		code: e.int().optional()
	})).optional()
})), zn = e.object({
	type: e.string().register(e.globalRegistry, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: e.string().register(e.globalRegistry, { description: "A short, human-readable summary of the problem type." }),
	status: e.int().register(e.globalRegistry, { description: "The HTTP status code for this occurrence." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence." }),
	instance: e.string().register(e.globalRegistry, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: e.array(e.object({
		type: e.string(),
		title: e.string(),
		detail: e.string(),
		instance: e.string().optional()
	})).register(e.globalRegistry, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(e.globalRegistry, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" }), Bn = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), S = e.object({
	date: _n,
	timezone: e.string(),
	timezone_type: Bn
}), Vn = e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), Hn = e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]).register(e.globalRegistry, { description: "Package Type." }), Un = e.object({
	type: e.enum(["start", "end"]),
	date_time: S
}), Wn = e.object({
	type: Vn.nullable(),
	package_type: Hn,
	delivery_time_frames: e.array(Un),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.enum(["boolean"]),
			enum: e.array(e.boolean())
		})
	})),
	price: Pn.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Gn = e.object({
	date: S,
	possibilities: e.array(Wn)
}), Kn = e.object({ data: e.object({ deliveries: e.array(Gn) }) }), qn = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Jn = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Yn = e.object({
	start: Jn,
	end: Jn,
	price: Pn,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: S.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Xn = e.object({
	date: qn,
	time: e.array(Yn)
}), Zn = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Qn = e.object({
	start: Jn.nullish(),
	type: Zn.optional(),
	price: Pn.optional()
}), C = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), $n = e.object({
	monday: C,
	tuesday: C,
	wednesday: C,
	thursday: C,
	friday: C,
	saturday: C,
	sunday: C
}), er = e.union([e.number().gte(-90).lte(90), e.string().regex(/^[-+]?(90|[0-8]?\d)(\.\d+)?$/)]), tr = e.union([e.number().gte(-180).lte(180), e.string().regex(/^[-+]?(180|(0?\d{0,2}|1[0-7]\d)(\.\d+)?)$/)]), nr = e.object({
	date: qn.nullish(),
	time: e.array(Qn).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: Jn.nullish(),
	price: e.int().optional(),
	price_comment: e.enum(["retail", "retailexpress"]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: $n.optional(),
	distance: e.string().optional(),
	latitude: er.optional(),
	longitude: tr.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), rr = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), ir = e.union([me, rr]), ar = e.object({
	status: ir.optional(),
	code: ge,
	title: e.string().optional(),
	message: e.string()
}), or = e.object({
	data: e.object({
		delivery: e.array(Xn),
		pickup: e.array(nr),
		message: e.string().optional()
	}),
	errors: e.array(e.union([ar, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
}), sr = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." }), cr = ve.and(e.object({
	status_code: sr.optional(),
	errors: e.array(e.object({
		status: sr.optional(),
		code: e.int().optional()
	})).optional()
})), lr = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), ur = e.object({ data: e.object({ download_url: lr }) }), dr = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), fr = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), pr = e.array(e.union([dr, fr])).nullable(), mr = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), hr = e.object({
	start: S.nullable(),
	end: S.nullable()
}), w = e.array(hr), gr = e.object({
	monday: w.optional(),
	tuesday: w.optional(),
	wednesday: w.optional(),
	thursday: w.optional(),
	friday: w.optional(),
	saturday: w.optional(),
	sunday: w.optional()
}).nullable(), _r = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: tr.nullish(),
	latitude: er.nullish(),
	available_days: pr.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: x.optional(),
	distance: e.number().nullish(),
	occupancy: mr.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: ze.nullish(),
	opening_hours: gr.optional()
}), vr = e.object({ data: e.object({ drop_off_points: e.array(_r) }) }), yr = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." }), br = ve.and(e.object({
	status_code: yr.optional(),
	errors: e.array(e.object({
		status: yr.optional(),
		code: e.literal(3100).optional()
	})).optional()
})), xr = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." }), Sr = ve.and(e.object({
	status_code: xr.optional(),
	errors: e.array(e.object({
		status: xr.optional(),
		code: e.int().optional()
	})).optional()
})), Cr = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), wr = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: S.nullish() })
})), T = e.object({
	start: S.nullable(),
	end: S.nullable()
}), Tr = e.object({
	monday: e.array(T),
	tuesday: e.array(T),
	wednesday: e.array(T),
	thursday: e.array(T),
	friday: e.array(T),
	saturday: e.array(T),
	sunday: e.array(T)
}), Er = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: ze.nullable(),
	opening_hours: Tr
}), Dr = e.object({
	address: Cr,
	possibilities: wr,
	location: Er
}), Or = e.object({ data: e.object({ pickup_locations: e.array(Dr) }) }), kr = e.object({ data: e.object({
	shipments: e.array(Dn).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) }).optional(),
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) }).optional()
}) }), Ar = e.object({ data: e.object({ ids: e.array(e.object({
	id: m,
	reference_identifier: tt
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) }), jr = e.array(e.object({
	id: m,
	reference_identifier: tt
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }), Mr = e.object({ data: e.union([e.object({
	ids: jr,
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) })
}), e.object({
	ids: jr,
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) })
})]) }), Nr = e.object({
	status: rr.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), Pr = e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: rr.optional(),
	errors: e.array(Nr).optional()
}), Fr = e.object({ data: e.object({
	shipments: e.array(Dn).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), Ir = e.object({
	uri: e.url(),
	barcode: e.string()
}), Lr = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), Rr = e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]).nullable(), zr = e.object({
	code: e.string(),
	status: ke.nullable(),
	main: Rr,
	description: e.string(),
	time: _n,
	delayed: e.boolean(),
	location: Lr
}), Br = e.array(zr), Vr = e.enum(["estimated", "expected"]).nullable(), Hr = e.object({
	start: S.nullable(),
	end: S.nullable()
}).nullable(), Ur = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), Wr = e.object({
	shipment_id: m,
	carrier: x,
	code: e.string(),
	description: e.string(),
	time: _n,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(Ir),
	recipient: Oe,
	sender: De,
	options: v,
	pickup: Ve,
	delayed: e.boolean(),
	location: Lr,
	status: e.object({
		current: ke,
		main: Rr,
		final: e.boolean()
	}),
	history: Br,
	delivery_moment_type: Vr.optional(),
	delivery_moment: Hr.optional(),
	signature: Ur.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), Gr = e.object({ data: e.object({ tracktraces: e.array(Wr).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), Kr = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), qr = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), Jr = e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]).register(e.globalRegistry, { description: "Package Type." }), E = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), Yr = e.object({
	additionalInsurance: E.optional(),
	deliverAtPostalPoint: E.optional(),
	freshFood: E.optional(),
	frozen: E.optional(),
	hideSender: E.optional(),
	noTracking: E.optional(),
	oversizedPackage: E.optional(),
	priorityDelivery: E.optional(),
	printReturnLabelAtDropOff: E.optional(),
	recipientOnlyDelivery: E.optional(),
	requiresAgeVerification: E.optional(),
	requiresCashOnDelivery: E.optional(),
	requiresReceiptCode: E.optional(),
	requiresSignature: E.optional(),
	returnOnFirstFailedDelivery: E.optional(),
	sameDayDelivery: E.optional(),
	saturdayDelivery: E.optional(),
	scheduledCollection: E.optional(),
	tracked: E.optional()
}), D = E.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), Xr = e.object({
	default: g.optional(),
	min: g.optional(),
	max: g.optional()
}), Zr = D.and(Xr), Qr = Yr.and(e.object({
	additionalInsurance: D.optional(),
	deliverAtPostalPoint: D.optional(),
	freshFood: D.optional(),
	frozen: D.optional(),
	hideSender: D.optional(),
	insurance: Zr.optional(),
	noTracking: D.optional(),
	oversizedPackage: D.optional(),
	priorityDelivery: D.optional(),
	printReturnLabelAtDropOff: D.optional(),
	recipientOnlyDelivery: D.optional(),
	requiresAgeVerification: D.optional(),
	requiresCashOnDelivery: D.optional(),
	requiresReceiptCode: D.optional(),
	requiresSignature: D.optional(),
	returnOnFirstFailedDelivery: D.optional(),
	sameDayDelivery: D.optional(),
	saturdayDelivery: D.optional(),
	scheduledCollection: D.optional(),
	tracked: D.optional()
})), $r = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), O = e.object({
	min: $r,
	max: $r,
	calculation: e.string()
}), ei = e.object({
	weight: O.optional(),
	width: O.optional(),
	length: O.optional(),
	height: O.optional(),
	girth: O.optional(),
	volumetricWeight: O.optional(),
	volume: O.optional(),
	lengthWidthHeightSum: O.optional()
}), ti = e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), ni = e.enum(["B2B", "B2C"]), ri = e.object({ max: e.int() }), ii = e.object({
	carrier: Kr,
	contract: qr.optional(),
	packageTypes: e.array(Jr),
	options: Qr,
	physicalProperties: ei,
	deliveryTypes: e.array(ti),
	transactionTypes: e.array(ni),
	collo: ri
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), ai = e.object({ results: e.array(ii).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), oi = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), si = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), k = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), ci = e.object({
	age_check: k.optional(),
	cash_on_delivery: k.optional(),
	collect: k.optional(),
	drop_off_at_postal_point: k.optional(),
	extra_assurance: k.optional(),
	fresh_food: k.optional(),
	frozen: k.optional(),
	hide_sender: k.optional(),
	large_format: k.optional(),
	no_tracking: k.optional(),
	only_recipient: k.optional(),
	printerless_return: k.optional(),
	priority_delivery: k.optional(),
	receipt_code: k.optional(),
	return: k.optional(),
	same_day_delivery: k.optional(),
	saturday_delivery: k.optional(),
	signature: k.optional(),
	tracked: k.optional()
}), A = k.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), li = e.object({
	default: g.optional(),
	min: g.optional(),
	max: g.optional()
}), ui = A.and(li), di = ci.and(e.object({
	age_check: A.optional(),
	cash_on_delivery: A.optional(),
	collect: A.optional(),
	drop_off_at_postal_point: A.optional(),
	extra_assurance: A.optional(),
	fresh_food: A.optional(),
	frozen: A.optional(),
	hide_sender: A.optional(),
	insurance: ui.optional(),
	large_format: A.optional(),
	no_tracking: A.optional(),
	only_recipient: A.optional(),
	printerless_return: A.optional(),
	priority_delivery: A.optional(),
	receipt_code: A.optional(),
	return: A.optional(),
	same_day_delivery: A.optional(),
	saturday_delivery: A.optional(),
	signature: A.optional(),
	tracked: A.optional()
})), fi = e.object({
	weight: O.optional(),
	width: O.optional(),
	length: O.optional(),
	height: O.optional(),
	girth: O.optional(),
	volumetric_weight: O.optional(),
	volume: O.optional(),
	length_width_height_sum: O.optional()
}), pi = e.object({
	carrier_id: oi,
	contract: si.optional(),
	package_types: e.array(_),
	options: di,
	physical_properties: fi,
	delivery_types: e.array(Zn),
	transaction_types: e.array(ni),
	collo: ri
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." }), mi = e.object({ data: e.object({ capabilities: e.array(pi).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) }), j = E.and(e.object({})), hi = j.and(Xr), gi = Yr.and(e.object({
	additionalInsurance: j.optional(),
	deliverAtPostalPoint: j.optional(),
	hideSender: j.optional(),
	insurance: hi.optional(),
	noTracking: j.optional(),
	oversizedPackage: j.optional(),
	priorityDelivery: j.optional(),
	printReturnLabelAtDropOff: j.optional(),
	recipientOnlyDelivery: j.optional(),
	requiresAgeVerification: j.optional(),
	requiresCashOnDelivery: j.optional(),
	requiresReceiptCode: j.optional(),
	requiresSignature: j.optional(),
	returnOnFirstFailedDelivery: j.optional(),
	sameDayDelivery: j.optional(),
	saturdayDelivery: j.optional(),
	scheduledCollection: j.optional(),
	tracked: j.optional()
})), _i = e.object({
	carrier: Kr,
	packageTypes: e.array(Jr),
	options: gi,
	deliveryTypes: e.array(ti),
	transactionTypes: e.array(ni),
	collo: ri
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), vi = e.object({ items: e.array(_i).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), M = k.and(e.object({})), yi = M.and(li), bi = ci.and(e.object({
	age_check: M.optional(),
	cash_on_delivery: M.optional(),
	collect: M.optional(),
	drop_off_at_postal_point: M.optional(),
	extra_assurance: M.optional(),
	hide_sender: M.optional(),
	insurance: yi.optional(),
	large_format: M.optional(),
	no_tracking: M.optional(),
	only_recipient: M.optional(),
	printerless_return: M.optional(),
	priority_delivery: M.optional(),
	receipt_code: M.optional(),
	return: M.optional(),
	same_day_delivery: M.optional(),
	saturday_delivery: M.optional(),
	signature: M.optional(),
	tracked: M.optional()
})), xi = e.object({
	carrier_id: oi,
	package_types: e.array(_),
	options: bi,
	delivery_types: e.array(Zn),
	transaction_types: e.array(ni),
	collo: ri
}).register(e.globalRegistry, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." }), Si = e.object({ data: e.object({ contract_definitions: e.array(xi).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) }), Ci = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), wi = e.enum([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), Ti = e.object({
	name: e.string(),
	key: e.string(),
	price: b,
	vat: b,
	priceWithVat: b
}).register(e.globalRegistry, { description: "A V2 Price object." }), Ei = e.object({
	base: Ti,
	charges: e.array(Ti),
	discounts: e.array(Ti),
	options: e.array(Ti),
	other: e.array(Ti),
	total: Ti
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), Di = e.object({
	carrier: Kr,
	contract: Ci.optional(),
	packageType: Jr,
	deliveryType: ti.optional(),
	shipmentType: wi,
	priceComposition: Ei
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), Oi = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), ki = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), Ai = e.object({
	name: e.string(),
	key: e.string(),
	price: b,
	vat: b,
	price_with_vat: b
}).register(e.globalRegistry, { description: "A V1 Price object." }), ji = e.object({
	base: Ai,
	charges: e.array(Ai),
	discounts: e.array(Ai),
	options: e.array(Ai),
	other: e.array(Ai),
	total: Ai
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), Mi = e.object({
	carrier_id: oi,
	contract: Oi.optional(),
	package_type: _,
	delivery_type: Zn.optional(),
	shipment_type: ki,
	price_composition: ji
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." }), Ni = e.object({ data: e.object({ rates: e.array(Mi).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) }), Pi = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]).nullable(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).nullable(),
	shipmentDirection: e.enum(["OUTBOUND", "INBOUND"]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), Fi = e.object({ results: e.array(Pi) }), Ii = e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]).register(e.globalRegistry, { description: "The notification template type." }), Li = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: Ii,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), Ri = e.object({ results: e.array(Li) }), zi = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Bi = e.object({ data: e.object({ webhook_subscriptions: e.array(zi) }) }), Vi = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Hi = e.object({ data: e.object({ webhook_subscriptions: e.array(Vi) }) }), Ui = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), Wi = e.string().min(6).max(32).regex(/^[a-zA-Z0-9\-\s]+$/), Gi = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Ki = e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), qi = e.union([Gi, Ki]).nullable(), Ji = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), Yi = e.string().length(2).regex(/^[A-Za-z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), N = Jn.nullable(), P = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.enum([
		"0",
		"1",
		"false",
		"true"
	])
]), Xi = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), Zi = qn.nullable(), Qi = Jn.nullable(), $i = e.string().nullable(), ea = e.string().regex(/^([0-6](;[0-6])*)?$/).nullable(), ta = e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), na = e.union([ta, e.unknown()]), ra = e.enum(["A4", "A6"]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), ia = er.nullable(), aa = tr.nullable(), oa = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), sa = e.union([
	_,
	e.array(_),
	e.string().regex(/^[1-7](;[1-7]){0,5}$/)
]), ca = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), la = e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), ua = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), da = e.union([la, ua]).nullable(), fa = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), pa = e.union([fa, e.string().regex(/^[0-4](;[1-4]){0,3}$/)]), ma = e.string().min(2).max(12).regex(/^[a-zA-Z0-9\-\s]{2,12}$/).nullable(), ha = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), F = e.union([ha, e.string().regex(/^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$/)]), ga = e.union([
	Ce,
	e.array(Ce),
	e.string().regex(/^[1-8](;[1-8]){0,7}$/)
]), _a = e.int().gte(1).lte(2147483647), I = e.union([
	_a,
	e.array(_a),
	e.string().regex(/^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$/)
]), va = e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), ya = e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), ba = e.union([
	ke,
	e.array(ke),
	e.string().regex(/^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$/)
]), xa = e.string().regex(/^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\1(?:;|$)))+;*$/), Sa = e.array(e.union([e.email(), e.string().max(0)])).max(4), Ca = e.object({
	cc: e.string().length(2),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string().max(0)]).nullish()
}), wa = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	state: e.string().max(2).optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	location_code: e.string().optional(),
	location_type: e.union([Be, ze]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Ta = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: Sa.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}),
		sender: Ca.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: v.and(e.unknown()),
		customs_declaration: y.optional(),
		carrier: x,
		pickup: wa.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
			recipient: e.object({
				cc: e.string().length(2).optional(),
				region: e.string().max(35).optional(),
				state: e.string().max(2).optional(),
				postal_code: e.string().max(10).optional(),
				city: e.string().min(1).max(35).optional(),
				street: e.string().min(1).max(40).optional(),
				street_additional_info: e.string().max(50).optional(),
				number: e.string().max(8).optional(),
				number_suffix: e.string().max(6).optional(),
				box_number: e.string().max(8).optional(),
				area: e.string().max(35).optional(),
				person: e.string().min(1).max(50).optional(),
				company: e.string().max(50).optional(),
				email: e.union([e.email(), e.string().max(0)]).optional(),
				secondary_emails: Sa.optional(),
				phone: e.string().max(25).optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: v.optional(),
			customs_declaration: y.optional(),
			carrier: x.optional(),
			pickup: wa.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string().length(2),
			city: e.string().min(1).max(255),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.enum(["mr", "mrs"]).optional(),
			last_name: e.string(),
			number: e.union([e.string().min(1), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string().min(8),
			postal_code: e.string().min(1),
			street: e.string().min(1),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).max(100)
}) }), Ea = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: Sa.optional(),
			phone: e.string().max(25).optional()
		}),
		sender: Ca.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: v.and(e.unknown()),
		customs_declaration: y.optional(),
		carrier: x,
		pickup: wa.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	})).min(1).max(100)
}) }), Da = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() }), Oa = e.literal(1).register(e.globalRegistry, { description: "Regular package." }), ka = e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), Aa = e.literal(6), ja = e.object({
	age_check: h.optional(),
	cooled_delivery: h.optional(),
	drop_off_at_postal_point: h.optional(),
	extra_assurance: h.optional(),
	hide_sender: h.optional(),
	large_format: h.optional(),
	only_recipient: h.optional(),
	receipt_code: h.optional(),
	return: h.optional(),
	same_day_delivery: h.optional(),
	saturday_delivery: h.optional(),
	signature: h.optional()
}), Ma = e.object({ options: Da.and(Me).and(ja).and(Le).and(e.object({
	contribution: g.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: h.optional()
})).optional() }), Na = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(17),
	e.literal(18)
]), Pa = e.object({ data: e.object({ return_shipments: e.array(Ma.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: Na,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: y.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Fa = e.object({ data: e.object({ return_shipments: e.array(Ma.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: Na,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: y.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Ia = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: x,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: Sa.optional(),
		phone: e.string().max(25).optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}),
	sender: Ca.optional(),
	options: v.and(e.unknown()),
	customs_declaration: y.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: wa.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2).optional(),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35).optional(),
			street: e.string().min(1).max(40).optional(),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).nullish(),
			number_suffix: e.string().max(6).nullish(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50).optional(),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: Sa.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: v.optional(),
		customs_declaration: y.optional(),
		carrier: x.optional(),
		pickup: wa.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string().length(2),
		city: e.string().min(1).max(255),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.enum(["mr", "mrs"]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string().min(1), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string().min(8),
		postal_code: e.string().min(1),
		street: e.string().min(1),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).min(1).max(100).optional() }) }), La = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: x,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: Sa.optional(),
		phone: e.string().max(25).optional()
	}),
	sender: Ca.optional(),
	options: v.and(e.unknown()),
	customs_declaration: y.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: wa.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).min(1).max(100).optional() }) }), Ra = e.enum([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]).register(e.globalRegistry, { description: "Pickup / drop-off location type used for capability and rates filtering." }), za = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: Kr.optional(),
	packageType: Jr.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), g]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: Ra.optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
}), Ba = e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: oi.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		fresh_food: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), g]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: ze.optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) }), Va = e.object({ carrier: e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]).optional() }), Ha = e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() }), Ua = e.object({
	city: e.string().min(1).max(100).register(e.globalRegistry, { description: "The city of the address." }).optional(),
	countryCode: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().min(1).max(100).register(e.globalRegistry, { description: "The street of the address." }).optional(),
	additionalInformation: e.string().min(1).max(100).register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().min(1).max(100).register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().min(1).max(100).register(e.globalRegistry, { description: "The state of the address." }).optional()
}), Wa = e.object({
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: Ra.optional()
}), Ga = e.object({
	address: Ua,
	location: Wa,
	retailNetworkId: e.enum(["PNPNL-01", "PNPBE-01"]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), Ka = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Ga.optional(),
	carrier: Kr,
	packageType: Jr,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: g.optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: g }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
}), qa = e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Ve.optional(),
	carrier_id: oi,
	package_type: _,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: g }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: g.optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})).min(1) }) }), Ja = e.union([e.object({
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.enum(["OUTBOUND"])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.enum(["INBOUND"])
})]), Ya = e.object({
	body: e.string().min(1),
	subject: e.string().min(1).max(255)
}), Xa = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), Za = e.object({ data: e.object({ webhook_subscriptions: e.array(Xa).min(1).optional() }) }), Qa = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
}), $a = e.object({ data: e.object({ webhook_subscriptions: e.array(Qa).min(1).optional() }) }), eo = e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), to = Wi, no = qi, ro = Gi, io = e.string().nullable(), ao = e.string().nullable(), oo = Ji, so = Yi, co = e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), lo = N, uo = N, fo = P.nullable(), po = Xi, mo = Zi, ho = Qi, go = $i, _o = e.int().gte(-1).lte(14).nullable(), vo = e.int().gte(0).nullable(), yo = ea, bo = e.int().gte(0).lte(14).nullable(), xo = e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), So = na, Co = P.nullable(), wo = e.string().nullable(), To = e.boolean(), Eo = e.union([ra, e.string().regex(/^[Aa][46]$/)]), Do = Xi, Oo = e.boolean(), ko = ia, Ao = e.int().nullable(), jo = e.boolean(), Mo = e.string().nullable(), No = aa, Po = N, Fo = N, Io = P.nullable(), Lo = e.string().nullable(), Ro = e.union([oa, e.string().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]), zo = sa, Bo = ca, Vo = da, Ho = pa, Uo = ma, Wo = e.string().nullable(), Go = e.string().nullable(), Ko = e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), qo = e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), Jo = F, Yo = ga, Xo = I, Zo = I, Qo = va, $o = ya, es = e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), ts = ba, ns = e.string().nullable(), rs = Wi, is = xa, as = nt, os = e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), ss = e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), cs = e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), ls = e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }), us = F, ds = Ta, fs = Ia, ps = za, ms = Va, hs = Ka, gs = Ja, _s = Ya, vs = Za, ys = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), bs = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" }), xs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: ma.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: da.optional(),
		shop_id: I.optional(),
		carrier: qi.optional(),
		delivery_date: Zi.optional(),
		delivery_time: Qi.optional(),
		cutoff_time: N.optional(),
		dropoff_days: ea.optional(),
		monday_delivery: P.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: na.optional(),
		exclude_parcel_lockers: P.nullish(),
		latitude: ia.optional(),
		longitude: aa.optional()
	}).optional()
}), Ss = Kn, Cs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: ma.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Gi.optional(),
		shop_id: I.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: N.optional(),
		min_cut_off_time: N.optional(),
		max_cut_off_time: N.optional(),
		latitude: ia.optional(),
		longitude: aa.optional(),
		exclude_parcel_lockers: P.nullish()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), ws = vr, Ts = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: ma.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: da.optional(),
		shop_id: I.optional(),
		carrier: qi.optional(),
		delivery_date: Zi.optional(),
		delivery_time: Qi.optional(),
		cutoff_time: N.optional(),
		dropoff_days: ea.optional(),
		monday_delivery: P.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: na.optional(),
		exclude_parcel_lockers: P.nullish(),
		latitude: ia.optional(),
		longitude: aa.optional()
	}).optional()
}), Es = Or, Ds = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Os = ur, ks = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Wi.optional(),
		carrier_id: Gi.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: P.nullish(),
		delivered: Xi.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: Xi.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: e.union([oa, e.string().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]).optional(),
		package_type: sa.optional(),
		page: ca.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: ga.optional(),
		shop_id: I.optional(),
		size: va.optional(),
		sort: ya.optional(),
		status: ba.optional(),
		transaction_status: nt.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), As = Fr, js = e.object({
	body: ds,
	path: e.never().optional(),
	query: e.object({
		format: e.union([ra, e.string().regex(/^[Aa][46]$/)]).optional(),
		positions: pa.optional(),
		collect_date: Ji.optional(),
		delivery_options_identifier: $i.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ms = kr, Ns = e.object({
	body: fs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ps = e.union([On, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]), Fs = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Is = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." }), Ls = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Rs = Fr, zs = e.object({
	body: ps,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Bs = ai, Vs = e.object({
	body: ms,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Hs = vi, Us = e.object({
	body: hs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ws = e.union([Di, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]), Gs = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({
		format: e.union([ra, e.string().regex(/^[Aa][46]$/)]).optional(),
		positions: pa.optional(),
		collect_date: Ji.optional(),
		delivery_options_identifier: $i.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ks = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), jn]), qs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Wi.optional(),
		country_code: Yi.optional(),
		external_identifier: Wi.optional(),
		extra_info: xa.optional(),
		postal_code: ma.optional(),
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Js = Gr, Ys = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: xa.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Xs = Gr, Zs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: I.optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Qs = Fi, $s = e.object({
	body: gs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), ec = Fi, tc = e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), nc = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." }), rc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), ic = Ri, ac = e.object({
	body: _s,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), oc = e.void().register(e.globalRegistry, { description: "Notification template update was successful." }), sc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), cc = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." }), lc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), uc = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." }), dc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), fc = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." }), pc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), mc = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." }), hc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), gc = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." }), _c = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), vc = Bi, yc = e.object({
	body: vs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), bc = Ui, xc = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Sc = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." }), Cc = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), wc = Bi, Tc = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), Ec = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), Dc = e.union([Ec, e.int()]), Oc = e.object({
	status: Tc.optional(),
	code: Dc.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), kc = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: Tc,
	errors: e.union([e.array(Oc), e.record(e.string(), Oc)])
}), Ac = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." });
kc.and(e.object({
	status_code: Ac.optional(),
	errors: e.array(e.object({
		status: Ac.optional(),
		code: e.int().optional()
	})).optional()
}));
var L = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), jc = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Mc = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Nc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Pc = e.string(), Fc = e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(), Ic = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), Lc = e.object({
	account_id: jc.optional(),
	person: e.string().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: Pc,
	region: e.string().nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	billing_email: Fc.optional(),
	secondary_emails: e.array(Ic).nullish(),
	box_number: e.string().nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Rc = Lc.and(e.object({
	person: e.unknown().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), zc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), Bc = e.object({
	currency: e.union([e.enum(["EUR"]), e.string()]),
	amount: e.int().gte(0)
}), Vc = e.object({ insurance: Bc.optional() }).and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), R = e.union([e.literal(0), e.literal(1)]), z = e.object({
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string()])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Hc = e.object({
	age_check: R.optional(),
	cash_on_delivery: z.optional(),
	collect: R.optional(),
	cooled_delivery: R.optional(),
	drop_off_at_postal_point: R.optional(),
	extra_assurance: R.optional(),
	fresh_food: R.optional(),
	frozen: R.optional(),
	hide_sender: R.optional(),
	large_format: R.optional(),
	no_tracking: R.optional(),
	only_recipient: R.optional(),
	priority_delivery: R.optional(),
	receipt_code: R.optional(),
	return: R.optional(),
	same_day_delivery: R.optional(),
	saturday_delivery: R.optional(),
	signature: R.optional(),
	tracked: R.optional()
}), Uc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), Wc = e.object({ package_type: Uc.optional() }), Gc = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Kc = e.object({ delivery_date: e.string().nullish() }), qc = e.object({ label_description: e.string().nullish() }), B = Vc.and(Hc).and(Wc).and(Gc).and(Kc).and(qc), Jc = e.object({
	save_recipient_address: R.optional(),
	delivery_notification: R.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: R.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: R.optional(),
		bcc_email: Fc.optional(),
		carrier_email_basic_notification: R.optional(),
		delivery_notification: R.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: R.optional(),
		email_on_handed_to_courier: R.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: R.optional(),
		send_track_trace_emails: R.optional()
	}).optional()
}).nullable(), Yc = e.union([e.enum([
	"retail",
	"locker",
	"post_office"
]), e.string()]).register(e.globalRegistry, { description: "Pickup / drop-off location type." }), Xc = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), Zc = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	location_type: e.union([Yc, Xc]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Qc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), $c = e.object({
	description: e.string(),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: z,
	classification: e.string(),
	country: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).optional()
}), V = e.object({
	contents: Qc,
	invoice: e.string().nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array($c)
}), el = e.int().gte(0).lte(999999999), tl = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), nl = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), rl = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), il = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), al = el, ol = tl.nullable(), sl = nl.nullable(), cl = rl.nullable(), ll = il.nullable(), ul = e.object({
	weight: el.optional(),
	height: tl.nullish(),
	width: nl.nullish(),
	length: rl.nullish(),
	volume: il.nullish(),
	carrier_weight: e.union([al, e.string()]).nullish(),
	carrier_height: ol.nullish(),
	carrier_width: sl.nullish(),
	carrier_length: cl.nullish(),
	carrier_volume: ll.nullish()
}).nullable(), dl = e.union([e.int(), e.string()]).nullable(), fl = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), pl = Zc, ml = e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }), hl = e.union([e.int().gte(0), e.string()]), H = e.object({
	currency: ml,
	amount: hl.nullable()
}).register(e.globalRegistry, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), gl = e.union([e.enum([
	"Facebook",
	"Google",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), e.string()]), _l = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), vl = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), U = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), yl = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), bl = e.string(), xl = e.string().nullable(), Sl = L.nullable(), Cl = jc, wl = Mc, Tl = Nc, El = Rc, Dl = Lc, Ol = zc, kl = B.and(e.unknown()), Al = Jc, jl = Zc, Ml = V.nullable(), Nl = ul, Pl = dl, Fl = fl, Il = pl, Ll = R, Rl = H, zl = e.string(), Bl = e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]), Vl = gl.nullable(), Hl = _l.nullable(), Ul = vl, Wl = U, Gl = yl, Kl = bl.nullable(), ql = xl, Jl = e.string(), Yl = e.string(), Xl = e.union([e.string(), e.int()]), Zl = e.string(), Ql = e.string(), $l = e.string(), eu = e.string(), tu = e.string(), nu = e.string().nullable(), ru = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().nullish(),
	first_name: e.string().nullish(),
	last_name: e.string().nullable(),
	email: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(),
	phone: e.string().nullable(),
	company: e.string().nullable(),
	street: Jl,
	street_additional_info: Yl.optional(),
	number: Xl,
	number_suffix: Zl.optional(),
	postal_code: Ql,
	city: $l,
	cc: eu,
	region: tu.optional(),
	box_number: nu.optional()
}), iu = ru.nullable(), au = L.nullable(), ou = e.string().nullable(), su = ou, cu = e.boolean().default(!1), lu = e.boolean().default(!1), uu = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), du = e.union([e.enum(["", "EUR"]), e.string()]), fu = du.nullable(), pu = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), mu = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), hu = e.array(e.object({
	uri: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]),
	barcode: e.string()
})), gu = hu, _u = e.string().nullable(), vu = e.uuid().max(36).nullable(), yu = e.int().nullable(), bu = e.string().nullable(), xu = e.record(e.string(), e.unknown()).nullable(), Su = e.string().nullable(), Cu = e.object({
	quantity: yu.optional(),
	order_line_identifier: bu.optional(),
	order_line: xu.optional(),
	picklist_identifier: Su.optional(),
	order_identifier: e.string().nullish()
}).nullable(), wu = e.array(Cu).nullable(), Tu = e.string().register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Eu = Tu, Du = Eu, Ou = Tu, ku = Ou, Au = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), ju = Au.nullable(), Mu = ju, Nu = Au.nullable(), Pu = Nu, Fu = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: L.nullable(),
	account_id: jc,
	shop_id: Mc,
	shipment_type: Nc,
	recipient: Rc,
	sender: Lc,
	status: zc,
	options: B.and(e.unknown()),
	general_settings: Jc,
	pickup: Zc,
	customs_declaration: V.nullable(),
	physical_properties: ul,
	reference_identifier: dl,
	transaction_status: fl,
	drop_off_point: pl,
	hidden: R,
	price: H,
	barcode: e.string(),
	region: e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]),
	external_provider: gl.nullable(),
	external_provider_id: _l.nullable(),
	payment_status: vl,
	carrier_id: U,
	platform_id: yl,
	origin: bl.nullable(),
	user_agent: xl,
	secondary_shipments: e.array(e.object({
		id: L,
		parent_id: Sl,
		account_id: Cl,
		shop_id: wl,
		shipment_type: Tl,
		recipient: El,
		sender: Dl,
		status: Ol,
		options: kl,
		general_settings: Al,
		pickup: jl,
		customs_declaration: Ml,
		physical_properties: Nl,
		reference_identifier: Pl,
		transaction_status: Fl,
		drop_off_point: Il,
		hidden: Ll,
		price: Rl,
		barcode: zl,
		region: Bl,
		external_provider: Vl,
		external_provider_id: Hl,
		payment_status: Ul,
		carrier_id: Wl,
		platform_id: Gl,
		origin: Kl,
		user_agent: ql,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: iu,
		multi_collo_main_shipment_id: au,
		external_identifier: su,
		delayed: cu,
		delivered: lu,
		amount: uu.optional(),
		currency: fu.optional(),
		contract_id: pu,
		link_consumer_portal: mu.optional(),
		partner_tracktraces: gu.optional(),
		pickup_request_number: _u.optional(),
		order_shipment_identifier: vu.optional(),
		shipped_items: wu.optional(),
		created: Du,
		modified: ku,
		created_by: Mu,
		modified_by: Pu
	})),
	collection_contact: ru.nullable(),
	multi_collo_main_shipment_id: L.nullable(),
	external_identifier: ou,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: du.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	partner_tracktraces: hu.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(Cu).nullish(),
	created: Eu,
	modified: Ou,
	created_by: ju,
	modified_by: Nu
}), Iu = e.object({ data: e.object({ shipments: e.array(Fu).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) });
e.union([e.string(), e.unknown()]);
var Lu = e.object({ url: e.url() }), Ru = e.object({ data: e.union([
	e.object({ pdf: Lu }),
	e.object({ pdfs: Lu }),
	e.object({ csvs: Lu }),
	e.object({ zpl: Lu }),
	e.object({ zpls: Lu })
]) }), zu = e.array(e.object({
	shipment_id: L,
	price: z,
	price_after_vat: z
}));
e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: zu,
	blocked_shipments: zu
}) }) });
var Bu = e.object({
	amount: e.int().nullable(),
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Vu = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Bu,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
});
e.object({ data: e.object({ payment_instructions: e.array(Vu) }) });
var Hu = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." });
kc.and(e.object({
	status_code: Hu.optional(),
	errors: e.array(e.object({
		status: Hu.optional(),
		code: e.int().optional()
	})).optional()
})), e.object({
	type: e.string().register(e.globalRegistry, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: e.string().register(e.globalRegistry, { description: "A short, human-readable summary of the problem type." }),
	status: e.int().register(e.globalRegistry, { description: "The HTTP status code for this occurrence." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence." }),
	instance: e.string().register(e.globalRegistry, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: e.array(e.object({
		type: e.string(),
		title: e.string(),
		detail: e.string(),
		instance: e.string().optional()
	})).register(e.globalRegistry, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(e.globalRegistry, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" });
var Uu = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), W = e.object({
	date: Tu,
	timezone: e.string(),
	timezone_type: Uu
}), Wu = e.union([e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), e.string()]), Gu = e.union([e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), Ku = e.object({
	type: e.union([e.enum(["start", "end"]), e.string()]),
	date_time: W
}), qu = e.object({
	type: Wu.nullable(),
	package_type: Gu,
	delivery_time_frames: e.array(Ku),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.union([e.enum(["boolean"]), e.string()]),
			enum: e.array(e.boolean())
		})
	})),
	price: Bu.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Ju = e.object({
	date: W,
	possibilities: e.array(qu)
}), Yu = e.object({ data: e.object({ deliveries: e.array(Ju) }) }), Xu = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Zu = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Qu = e.object({
	start: Zu,
	end: Zu,
	price: Bu,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: W.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), $u = e.object({
	date: Xu,
	time: e.array(Qu)
}), ed = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), td = e.object({
	start: Zu.nullish(),
	type: ed.optional(),
	price: Bu.optional()
}), nd = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), rd = e.object({
	monday: nd,
	tuesday: nd,
	wednesday: nd,
	thursday: nd,
	friday: nd,
	saturday: nd,
	sunday: nd
}), id = e.union([e.number().gte(-90).lte(90), e.string()]), ad = e.union([e.number().gte(-180).lte(180), e.string()]), od = e.object({
	date: Xu.nullish(),
	time: e.array(td).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: Zu.nullish(),
	price: e.int().optional(),
	price_comment: e.union([e.enum(["retail", "retailexpress"]), e.string()]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: rd.optional(),
	distance: e.string().optional(),
	latitude: id.optional(),
	longitude: ad.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), sd = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), cd = e.union([Tc, sd]), ld = e.object({
	status: cd.optional(),
	code: Dc,
	title: e.string().optional(),
	message: e.string()
});
e.object({
	data: e.object({
		delivery: e.array($u),
		pickup: e.array(od),
		message: e.string().optional()
	}),
	errors: e.array(e.union([ld, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
});
var ud = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." });
kc.and(e.object({
	status_code: ud.optional(),
	errors: e.array(e.object({
		status: ud.optional(),
		code: e.int().optional()
	})).optional()
}));
var dd = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), fd = e.object({ data: e.object({ download_url: dd }) }), pd = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), md = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), hd = e.array(e.union([pd, md])).nullable(), gd = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), _d = e.object({
	start: W.nullable(),
	end: W.nullable()
}), G = e.array(_d), vd = e.object({
	monday: G.optional(),
	tuesday: G.optional(),
	wednesday: G.optional(),
	thursday: G.optional(),
	friday: G.optional(),
	saturday: G.optional(),
	sunday: G.optional()
}).nullable(), yd = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: ad.nullish(),
	latitude: id.nullish(),
	available_days: hd.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: U.optional(),
	distance: e.number().nullish(),
	occupancy: gd.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: Yc.nullish(),
	opening_hours: vd.optional()
}), bd = e.object({ data: e.object({ drop_off_points: e.array(yd) }) }), xd = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." });
kc.and(e.object({
	status_code: xd.optional(),
	errors: e.array(e.object({
		status: xd.optional(),
		code: e.literal(3100).optional()
	})).optional()
}));
var Sd = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." });
kc.and(e.object({
	status_code: Sd.optional(),
	errors: e.array(e.object({
		status: Sd.optional(),
		code: e.int().optional()
	})).optional()
}));
var Cd = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), wd = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: W.nullish() })
})), Td = e.object({
	start: W.nullable(),
	end: W.nullable()
}), Ed = e.object({
	monday: e.array(Td),
	tuesday: e.array(Td),
	wednesday: e.array(Td),
	thursday: e.array(Td),
	friday: e.array(Td),
	saturday: e.array(Td),
	sunday: e.array(Td)
}), Dd = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: Yc.nullable(),
	opening_hours: Ed
}), Od = e.object({
	address: Cd,
	possibilities: wd,
	location: Dd
}), kd = e.object({ data: e.object({ pickup_locations: e.array(Od) }) }), Ad = e.object({ data: e.object({
	shipments: e.array(Fu).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string() }).optional(),
	zpl: e.object({ url: e.string() }).optional()
}) });
e.object({ data: e.object({ ids: e.array(e.object({
	id: L,
	reference_identifier: dl
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) });
var jd = e.array(e.object({
	id: L,
	reference_identifier: dl
})).register(e.globalRegistry, { description: "A list of Shipment IDs." });
e.object({ data: e.union([e.object({
	ids: jd,
	pdf: e.object({ url: e.string() })
}), e.object({
	ids: jd,
	zpl: e.object({ url: e.string() })
})]) });
var Md = e.object({
	status: sd.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
});
e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: sd.optional(),
	errors: e.array(Md).optional()
});
var Nd = e.object({ data: e.object({
	shipments: e.array(Fu).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), Pd = e.object({
	uri: e.url(),
	barcode: e.string()
}), Fd = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), Id = e.union([e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]), e.string()]).nullable(), Ld = e.object({
	code: e.string(),
	status: zc.nullable(),
	main: Id,
	description: e.string(),
	time: Tu,
	delayed: e.boolean(),
	location: Fd
}), Rd = e.array(Ld), zd = e.union([e.enum(["estimated", "expected"]), e.string()]).nullable(), Bd = e.object({
	start: W.nullable(),
	end: W.nullable()
}).nullable(), Vd = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), Hd = e.object({
	shipment_id: L,
	carrier: U,
	code: e.string(),
	description: e.string(),
	time: Tu,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(Pd),
	recipient: Rc,
	sender: Lc,
	options: B,
	pickup: Zc,
	delayed: e.boolean(),
	location: Fd,
	status: e.object({
		current: zc,
		main: Id,
		final: e.boolean()
	}),
	history: Rd,
	delivery_moment_type: zd.optional(),
	delivery_moment: Bd.optional(),
	signature: Vd.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), Ud = e.object({ data: e.object({ tracktraces: e.array(Hd).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), Wd = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), e.string()]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), Gd = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), Kd = e.union([e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), K = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), qd = e.object({
	additionalInsurance: K.optional(),
	deliverAtPostalPoint: K.optional(),
	freshFood: K.optional(),
	frozen: K.optional(),
	hideSender: K.optional(),
	noTracking: K.optional(),
	oversizedPackage: K.optional(),
	priorityDelivery: K.optional(),
	printReturnLabelAtDropOff: K.optional(),
	recipientOnlyDelivery: K.optional(),
	requiresAgeVerification: K.optional(),
	requiresCashOnDelivery: K.optional(),
	requiresReceiptCode: K.optional(),
	requiresSignature: K.optional(),
	returnOnFirstFailedDelivery: K.optional(),
	sameDayDelivery: K.optional(),
	saturdayDelivery: K.optional(),
	scheduledCollection: K.optional(),
	tracked: K.optional()
}), q = K.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), Jd = e.object({
	default: z.optional(),
	min: z.optional(),
	max: z.optional()
}), Yd = q.and(Jd), Xd = qd.and(e.object({
	additionalInsurance: q.optional(),
	deliverAtPostalPoint: q.optional(),
	freshFood: q.optional(),
	frozen: q.optional(),
	hideSender: q.optional(),
	insurance: Yd.optional(),
	noTracking: q.optional(),
	oversizedPackage: q.optional(),
	priorityDelivery: q.optional(),
	printReturnLabelAtDropOff: q.optional(),
	recipientOnlyDelivery: q.optional(),
	requiresAgeVerification: q.optional(),
	requiresCashOnDelivery: q.optional(),
	requiresReceiptCode: q.optional(),
	requiresSignature: q.optional(),
	returnOnFirstFailedDelivery: q.optional(),
	sameDayDelivery: q.optional(),
	saturdayDelivery: q.optional(),
	scheduledCollection: q.optional(),
	tracked: q.optional()
})), Zd = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.union([e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), J = e.object({
	min: Zd,
	max: Zd,
	calculation: e.string()
}), Qd = e.object({
	weight: J.optional(),
	width: J.optional(),
	length: J.optional(),
	height: J.optional(),
	girth: J.optional(),
	volumetricWeight: J.optional(),
	volume: J.optional(),
	lengthWidthHeightSum: J.optional()
}), $d = e.union([e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), e.string()]), ef = e.union([e.enum(["B2B", "B2C"]), e.string()]), tf = e.object({ max: e.int() }), nf = e.object({
	carrier: Wd,
	contract: Gd.optional(),
	packageTypes: e.array(Kd),
	options: Xd,
	physicalProperties: Qd,
	deliveryTypes: e.array($d),
	transactionTypes: e.array(ef),
	collo: tf
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), rf = e.object({ results: e.array(nf).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), af = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), of = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), Y = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), sf = e.object({
	age_check: Y.optional(),
	cash_on_delivery: Y.optional(),
	collect: Y.optional(),
	drop_off_at_postal_point: Y.optional(),
	extra_assurance: Y.optional(),
	fresh_food: Y.optional(),
	frozen: Y.optional(),
	hide_sender: Y.optional(),
	large_format: Y.optional(),
	no_tracking: Y.optional(),
	only_recipient: Y.optional(),
	printerless_return: Y.optional(),
	priority_delivery: Y.optional(),
	receipt_code: Y.optional(),
	return: Y.optional(),
	same_day_delivery: Y.optional(),
	saturday_delivery: Y.optional(),
	signature: Y.optional(),
	tracked: Y.optional()
}), X = Y.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), cf = e.object({
	default: z.optional(),
	min: z.optional(),
	max: z.optional()
}), lf = X.and(cf), uf = sf.and(e.object({
	age_check: X.optional(),
	cash_on_delivery: X.optional(),
	collect: X.optional(),
	drop_off_at_postal_point: X.optional(),
	extra_assurance: X.optional(),
	fresh_food: X.optional(),
	frozen: X.optional(),
	hide_sender: X.optional(),
	insurance: lf.optional(),
	large_format: X.optional(),
	no_tracking: X.optional(),
	only_recipient: X.optional(),
	printerless_return: X.optional(),
	priority_delivery: X.optional(),
	receipt_code: X.optional(),
	return: X.optional(),
	same_day_delivery: X.optional(),
	saturday_delivery: X.optional(),
	signature: X.optional(),
	tracked: X.optional()
})), df = e.object({
	weight: J.optional(),
	width: J.optional(),
	length: J.optional(),
	height: J.optional(),
	girth: J.optional(),
	volumetric_weight: J.optional(),
	volume: J.optional(),
	length_width_height_sum: J.optional()
}), ff = e.object({
	carrier_id: af,
	contract: of.optional(),
	package_types: e.array(Uc),
	options: uf,
	physical_properties: df,
	delivery_types: e.array(ed),
	transaction_types: e.array(ef),
	collo: tf
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." });
e.object({ data: e.object({ capabilities: e.array(ff).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) });
var Z = K.and(e.object({})), pf = Z.and(Jd), mf = qd.and(e.object({
	additionalInsurance: Z.optional(),
	deliverAtPostalPoint: Z.optional(),
	hideSender: Z.optional(),
	insurance: pf.optional(),
	noTracking: Z.optional(),
	oversizedPackage: Z.optional(),
	priorityDelivery: Z.optional(),
	printReturnLabelAtDropOff: Z.optional(),
	recipientOnlyDelivery: Z.optional(),
	requiresAgeVerification: Z.optional(),
	requiresCashOnDelivery: Z.optional(),
	requiresReceiptCode: Z.optional(),
	requiresSignature: Z.optional(),
	returnOnFirstFailedDelivery: Z.optional(),
	sameDayDelivery: Z.optional(),
	saturdayDelivery: Z.optional(),
	scheduledCollection: Z.optional(),
	tracked: Z.optional()
})), hf = e.object({
	carrier: Wd,
	packageTypes: e.array(Kd),
	options: mf,
	deliveryTypes: e.array($d),
	transactionTypes: e.array(ef),
	collo: tf
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), gf = e.object({ items: e.array(hf).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), Q = Y.and(e.object({})), _f = Q.and(cf), vf = sf.and(e.object({
	age_check: Q.optional(),
	cash_on_delivery: Q.optional(),
	collect: Q.optional(),
	drop_off_at_postal_point: Q.optional(),
	extra_assurance: Q.optional(),
	hide_sender: Q.optional(),
	insurance: _f.optional(),
	large_format: Q.optional(),
	no_tracking: Q.optional(),
	only_recipient: Q.optional(),
	printerless_return: Q.optional(),
	priority_delivery: Q.optional(),
	receipt_code: Q.optional(),
	return: Q.optional(),
	same_day_delivery: Q.optional(),
	saturday_delivery: Q.optional(),
	signature: Q.optional(),
	tracked: Q.optional()
})), yf = e.object({
	carrier_id: af,
	package_types: e.array(Uc),
	options: vf,
	delivery_types: e.array(ed),
	transaction_types: e.array(ef),
	collo: tf
}).register(e.globalRegistry, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." });
e.object({ data: e.object({ contract_definitions: e.array(yf).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) });
var bf = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), xf = e.union([e.enum([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), e.string()]), Sf = e.object({
	name: e.string(),
	key: e.string(),
	price: H,
	vat: H,
	priceWithVat: H
}).register(e.globalRegistry, { description: "A V2 Price object." }), Cf = e.object({
	base: Sf,
	charges: e.array(Sf),
	discounts: e.array(Sf),
	options: e.array(Sf),
	other: e.array(Sf),
	total: Sf
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), wf = e.object({
	carrier: Wd,
	contract: bf.optional(),
	packageType: Kd,
	deliveryType: $d.optional(),
	shipmentType: xf,
	priceComposition: Cf
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), Tf = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), Ef = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), Df = e.object({
	name: e.string(),
	key: e.string(),
	price: H,
	vat: H,
	price_with_vat: H
}).register(e.globalRegistry, { description: "A V1 Price object." }), Of = e.object({
	base: Df,
	charges: e.array(Df),
	discounts: e.array(Df),
	options: e.array(Df),
	other: e.array(Df),
	total: Df
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), kf = e.object({
	carrier_id: af,
	contract: Tf.optional(),
	package_type: Uc,
	delivery_type: ed.optional(),
	shipment_type: Ef,
	price_composition: Of
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." });
e.object({ data: e.object({ rates: e.array(kf).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) });
var Af = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]).nullable(),
	countryCode: e.string().nullable(),
	shipmentDirection: e.union([e.enum(["OUTBOUND", "INBOUND"]), e.string()]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), jf = e.object({ results: e.array(Af) }), Mf = e.union([e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]), e.string()]).register(e.globalRegistry, { description: "The notification template type." }), Nf = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: Mf,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), Pf = e.object({ results: e.array(Nf) }), Ff = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), If = e.object({ data: e.object({ webhook_subscriptions: e.array(Ff) }) }), Lf = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" });
e.object({ data: e.object({ webhook_subscriptions: e.array(Lf) }) });
var Rf = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), zf = e.string(), Bf = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Vf = e.union([e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Hf = e.union([Bf, Vf]).nullable(), Uf = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), Wf = e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), Gf = Zu.nullable(), $ = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.union([e.enum([
		"0",
		"1",
		"false",
		"true"
	]), e.string()])
]), Kf = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), qf = Xu.nullable(), Jf = Zu.nullable(), Yf = e.string().nullable(), Xf = e.string().nullable(), Zf = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), e.string()]), Qf = e.union([Zf, e.unknown()]), $f = e.union([e.enum(["A4", "A6"]), e.string()]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), ep = id.nullable(), tp = ad.nullable(), np = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), rp = e.union([
	Uc,
	e.array(Uc),
	e.string()
]), ip = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), ap = e.union([e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), e.string()]), op = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), e.string()]), sp = e.union([ap, op]).nullable(), cp = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), lp = e.union([cp, e.string()]), up = e.string().nullable(), dp = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), fp = e.union([dp, e.string()]), pp = e.union([
	Nc,
	e.array(Nc),
	e.string()
]), mp = e.int().gte(1).lte(2147483647), hp = e.union([
	mp,
	e.array(mp),
	e.string()
]), gp = e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), _p = e.union([e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), e.string()]), vp = e.union([
	zc,
	e.array(zc),
	e.string()
]), yp = e.string(), bp = e.array(e.union([e.email(), e.string()])), xp = e.object({
	cc: e.string(),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string()]).nullish()
}), Sp = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	state: e.string().optional(),
	cc: e.string().optional(),
	location_code: e.string().optional(),
	location_type: e.union([Xc, Yc]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Cp = e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: bp.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}),
		sender: xp.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: B.and(e.unknown()),
		customs_declaration: V.optional(),
		carrier: U,
		pickup: Sp.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string()]).optional(),
			recipient: e.object({
				cc: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				postal_code: e.string().optional(),
				city: e.string().optional(),
				street: e.string().optional(),
				street_additional_info: e.string().optional(),
				number: e.string().optional(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				area: e.string().optional(),
				person: e.string().optional(),
				company: e.string().optional(),
				email: e.union([e.email(), e.string()]).optional(),
				secondary_emails: bp.optional(),
				phone: e.string().optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: B.optional(),
			customs_declaration: V.optional(),
			carrier: U.optional(),
			pickup: Sp.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string(),
			city: e.string(),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
			last_name: e.string(),
			number: e.union([e.string(), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string(),
			postal_code: e.string(),
			street: e.string(),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	}))
}) });
e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: bp.optional(),
			phone: e.string().optional()
		}),
		sender: xp.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: B.and(e.unknown()),
		customs_declaration: V.optional(),
		carrier: U,
		pickup: Sp.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	}))
}) });
var wp = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() });
e.literal(1).register(e.globalRegistry, { description: "Regular package." }), e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), e.literal(6);
var Tp = e.object({
	age_check: R.optional(),
	cooled_delivery: R.optional(),
	drop_off_at_postal_point: R.optional(),
	extra_assurance: R.optional(),
	hide_sender: R.optional(),
	large_format: R.optional(),
	only_recipient: R.optional(),
	receipt_code: R.optional(),
	return: R.optional(),
	same_day_delivery: R.optional(),
	saturday_delivery: R.optional(),
	signature: R.optional()
}), Ep = e.object({ options: wp.and(Vc).and(Tp).and(qc).and(e.object({
	contribution: z.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: R.optional()
})).optional() }), Dp = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(17),
	e.literal(18)
]);
e.object({ data: e.object({ return_shipments: e.array(Ep.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: Dp,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: V.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) }), e.object({ data: e.object({ return_shipments: e.array(Ep.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: Dp,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: V.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) });
var Op = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: U,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: bp.optional(),
		phone: e.string().optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}),
	sender: xp.optional(),
	options: B.and(e.unknown()),
	customs_declaration: V.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Sp.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string().optional(),
			street: e.string().optional(),
			street_additional_info: e.string().optional(),
			number: e.string().nullish(),
			number_suffix: e.string().nullish(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string().optional(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: bp.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: B.optional(),
		customs_declaration: V.optional(),
		carrier: U.optional(),
		pickup: Sp.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string(),
		city: e.string(),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string(), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string(),
		postal_code: e.string(),
		street: e.string(),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).optional() }) });
e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: U,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: bp.optional(),
		phone: e.string().optional()
	}),
	sender: xp.optional(),
	options: B.and(e.unknown()),
	customs_declaration: V.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Sp.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).optional() }) });
var kp = e.union([e.enum([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]), e.string()]).register(e.globalRegistry, { description: "Pickup / drop-off location type used for capability and rates filtering." }), Ap = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: Wd.optional(),
	packageType: Kd.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), z]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: kp.optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
});
e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: af.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		fresh_food: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), z]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: Yc.optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) });
var jp = e.object({ carrier: e.union([e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]), e.string()]).optional() });
e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() });
var Mp = e.object({
	city: e.string().register(e.globalRegistry, { description: "The city of the address." }).optional(),
	countryCode: e.string().register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().register(e.globalRegistry, { description: "The street of the address." }).optional(),
	additionalInformation: e.string().register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().register(e.globalRegistry, { description: "The state of the address." }).optional()
}), Np = e.object({
	name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: kp.optional()
}), Pp = e.object({
	address: Mp,
	location: Np,
	retailNetworkId: e.union([e.enum(["PNPNL-01", "PNPBE-01"]), e.string()]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), Fp = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Pp.optional(),
	carrier: Wd,
	packageType: Kd,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: z.optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: z }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
});
e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Zc.optional(),
	carrier_id: af,
	package_type: Uc,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: z }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: z.optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})) }) });
var Ip = e.union([e.object({
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.union([e.enum(["OUTBOUND"]), e.string()])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.union([e.enum(["INBOUND"]), e.string()])
})]), Lp = e.object({
	body: e.string(),
	subject: e.string()
}), Rp = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), zp = e.object({ data: e.object({ webhook_subscriptions: e.array(Rp).optional() }) }), Bp = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
});
e.object({ data: e.object({ webhook_subscriptions: e.array(Bp).optional() }) }), e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), e.string().nullable(), e.string().nullable(), e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), $.nullable(), e.int().gte(-1).lte(14).nullable(), e.int().gte(0).nullable(), e.int().gte(0).lte(14).nullable(), e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), $.nullable(), e.string().nullable(), e.boolean(), e.union([$f, e.string()]), e.boolean(), e.int().nullable(), e.boolean(), e.string().nullable(), $.nullable(), e.string().nullable(), e.union([np, e.string()]), e.string().nullable(), e.string().nullable(), e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), e.string().nullable(), e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), e.string().register(e.globalRegistry, { description: "Filter by webhook event type." });
var Vp = Cp, Hp = Op, Up = Ap, Wp = jp, Gp = Fp, Kp = Ip, qp = Lp, Jp = zp;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Yp = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: up.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: sp.optional(),
		shop_id: hp.optional(),
		carrier: Hf.optional(),
		delivery_date: qf.optional(),
		delivery_time: Jf.optional(),
		cutoff_time: Gf.optional(),
		dropoff_days: Xf.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Qf.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: ep.optional(),
		longitude: tp.optional()
	}).optional()
});
var Xp = Yu;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: up.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Bf.optional(),
		shop_id: hp.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: Gf.optional(),
		min_cut_off_time: Gf.optional(),
		max_cut_off_time: Gf.optional(),
		latitude: ep.optional(),
		longitude: tp.optional(),
		exclude_parcel_lockers: $.nullish()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Zp = bd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: up.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: sp.optional(),
		shop_id: hp.optional(),
		carrier: Hf.optional(),
		delivery_date: qf.optional(),
		delivery_time: Jf.optional(),
		cutoff_time: Gf.optional(),
		dropoff_days: Xf.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Qf.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: ep.optional(),
		longitude: tp.optional()
	}).optional()
});
var Qp = kd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var $p = fd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: zf.optional(),
		carrier_id: Bf.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: $.nullish(),
		delivered: Kf.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: Kf.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: e.union([np, e.string()]).optional(),
		package_type: rp.optional(),
		page: ip.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: pp.optional(),
		shop_id: hp.optional(),
		size: gp.optional(),
		sort: _p.optional(),
		status: vp.optional(),
		transaction_status: fl.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var em = Nd;
e.object({
	body: Vp,
	path: e.never().optional(),
	query: e.object({
		format: e.union([$f, e.string()]).optional(),
		positions: lp.optional(),
		collect_date: Uf.optional(),
		delivery_options_identifier: Yf.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var tm = Ad;
e.object({
	body: Hp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var nm = e.union([Iu, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var rm = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var im = Nd;
e.object({
	body: Up,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var am = rf;
e.object({
	body: Wp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var om = gf;
e.object({
	body: Gp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var sm = e.union([wf, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.object({
		format: e.union([$f, e.string()]).optional(),
		positions: lp.optional(),
		collect_date: Uf.optional(),
		delivery_options_identifier: Yf.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var cm = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), Ru]);
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: zf.optional(),
		country_code: Wf.optional(),
		external_identifier: zf.optional(),
		extra_info: yp.optional(),
		postal_code: up.optional(),
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var lm = Ud;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.object({
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: yp.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var um = Ud;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: hp.optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var dm = jf;
e.object({
	body: Kp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var fm = jf;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var pm = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var mm = Pf;
e.object({
	body: qp,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var hm = e.void().register(e.globalRegistry, { description: "Notification template update was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var gm = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var _m = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var vm = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var ym = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var bm = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var xm = If;
e.object({
	body: Jp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Sm = Rf;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Cm = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: fp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var wm = If, Tm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await ys.parseAsync(e),
	responseValidator: async (e) => await Yp.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/",
	...e
}), Em = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await xs.parseAsync(e),
	responseValidator: async (e) => await Xp.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/delivery_options",
	...e
}), Dm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Cs.parseAsync(e),
	responseValidator: async (e) => await Zp.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/drop_off_points",
	...e
}), Om = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Ts.parseAsync(e),
	responseValidator: async (e) => await Qp.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/pickup_locations",
	...e
}), km = (e) => (e?.client ?? p).post({
	requestValidator: async (e) => await Ds.parseAsync(e),
	responseValidator: async (e) => await $p.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/return_shipments",
	...e
}), Am = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await ks.parseAsync(e),
	responseValidator: async (e) => await em.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e
}), jm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await js.parseAsync(e),
	responseValidator: async (e) => await tm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), Mm = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await Ns.parseAsync(e),
	responseValidator: async (e) => await nm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), Nm = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await Fs.parseAsync(e),
	responseValidator: async (e) => await rm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), Pm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Ls.parseAsync(e),
	responseValidator: async (e) => await im.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), Fm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await zs.parseAsync(e),
	responseValidator: async (e) => await am.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Im = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Vs.parseAsync(e),
	responseValidator: async (e) => await om.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities/contract-definitions",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Lm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Us.parseAsync(e),
	responseValidator: async (e) => await sm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/rates",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Rm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Gs.parseAsync(e),
	responseValidator: async (e) => await cm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipment_labels/{ids}",
	...e
}), zm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await qs.parseAsync(e),
	responseValidator: async (e) => await lm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces",
	...e
}), Bm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Ys.parseAsync(e),
	responseValidator: async (e) => await um.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces/{ids}",
	...e
}), Vm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Zs.parseAsync(e),
	responseValidator: async (e) => await dm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e
}), Hm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await $s.parseAsync(e),
	responseValidator: async (e) => await fm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Um = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await tc.parseAsync(e),
	responseValidator: async (e) => await pm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{ids}",
	...e
}), Wm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await rc.parseAsync(e),
	responseValidator: async (e) => await mm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates",
	...e
}), Gm = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await ac.parseAsync(e),
	responseValidator: async (e) => await hm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Km = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await sc.parseAsync(e),
	responseValidator: async (e) => await gm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/disable",
	...e
}), qm = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await lc.parseAsync(e),
	responseValidator: async (e) => await _m.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/enable",
	...e
}), Jm = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await dc.parseAsync(e),
	responseValidator: async (e) => await vm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/disable",
	...e
}), Ym = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await pc.parseAsync(e),
	responseValidator: async (e) => await ym.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/enable",
	...e
}), Xm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await hc.parseAsync(e),
	responseValidator: async (e) => await bm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/test",
	...e
}), Zm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await _c.parseAsync(e),
	responseValidator: async (e) => await xm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions",
	...e
}), Qm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await yc.parseAsync(e),
	responseValidator: async (e) => await Sm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions",
	...e,
	headers: {
		"Content-Type": "application/json;version=1.1",
		...e.headers
	}
}), $m = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await xc.parseAsync(e),
	responseValidator: async (e) => await Cm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), eh = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Cc.parseAsync(e),
	responseValidator: async (e) => await wm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), th = "https://api.myparcel.nl", nh = "https://api.acceptance.myparcel.nl";
//#endregion
export { nn as $, ti as $a, ns as $c, Xr as $i, Zs as $n, wn as $o, gs as $r, Qi as $s, va as $t, Gm as A, Oa as Aa, vr as Ac, bi as Ai, dc as An, Rr as Ao, os as Ar, gt as As, Nr as At, Ht as B, Ga as Ba, On as Bc, Qr as Bi, ar as Bn, Xe as Bo, fn as Br, ke as Bs, rr as Bt, Fm as C, Me as Ca, Kn as Cc, Ni as Ci, po as Cn, $n as Co, Ao as Cr, ln as Cs, Pn as Ct, jm as D, Pe as Da, gr as Dc, hi as Di, _o as Dn, ot as Do, Fo as Dr, Tt as Ds, Cn as Dt, Lm as E, ja as Ea, pr as Ec, yi as Ei, ho as En, Qn as Eo, No as Er, _t as Es, vn as Et, Te as F, qe as Fa, Tr as Fc, ui as Fi, xo as Fn, dt as Fo, Ri as Fr, Rt as Fs, Ln as Ft, lt as G, Ma as Ga, Gr as Gc, Kr as Gi, To as Gn, Ve as Go, Vo as Gr, Wi as Gs, Yi as Gt, Kt as H, tt as Ha, jr as Hc, ei as Hi, Co as Hn, $e as Ho, dn as Hr, Ur as Hs, ha as Ht, qt as I, Je as Ia, Dr as Ic, Zr as Ii, lc as In, ft as Io, cs as Ir, Oe as Is, xr as It, Se as J, Ce as Ja, Zo as Jc, k as Ji, Ss as Jn, At as Jo, ms as Jr, Ki as Js, I as Jt, la as K, wi as Ka, Yo as Kc, si as Ki, Eo as Kn, mt as Ko, Ho as Kr, Gi as Ks, Xi as Kt, Gt as L, We as La, wr as Lc, A as Li, uc as Ln, sn as Lo, Lo as Lr, De as Ls, ye as Lt, Xm as M, Aa as Ma, Or as Mc, pi as Mi, vo as Mn, Dn as Mo, Ja as Mr, ht as Ms, ge as Mt, xe as N, Jr as Na, Cr as Nc, ii as Ni, yo as Nn, Zt as No, Ya as Nr, yt as Ns, he as Nt, km as O, Da as Oa, hr as Oc, M as Oi, sc as On, st as Oo, Po as Or, jt as Os, bn as Ot, Jt as P, Ge as Pa, Er as Pc, ri as Pi, bo as Pn, rt as Po, Fi as Pr, Et as Ps, me as Pt, to as Q, Zn as Qa, ts as Qc, li as Qi, bs as Qn, yn as Qo, Bs as Qr, $i as Qs, ca as Qt, Wt as R, Ke as Ra, T as Rc, D as Ri, pc as Rn, ct as Ro, Ro as Rr, Ee as Rs, sr as Rt, eh as S, je as Sa, or as Sc, Ka as Si, Sc as Sn, Un as So, ko as Sr, St as Ss, tr as St, Hm as T, Ne as Ta, _r as Tc, _i as Ti, go as Tn, nr as To, Mo as Tr, kt as Ts, Bn as Tt, zt as U, Ca as Ua, Mr as Uc, O as Ui, wo as Un, Ye as Uo, zo as Ur, Lr as Us, F as Ut, Ut as V, Sa as Va, Ar as Vc, fi as Vi, So as Vn, Qe as Vo, mn as Vr, Wr as Vs, ir as Vt, Bt as W, v as Wa, Fr as Wc, oi as Wi, is as Wn, Ze as Wo, Bo as Wr, Jo as Ws, P as Wt, ua as X, Na as Xa, $o as Xc, ci as Xi, ws as Xn, Yt as Xo, Hs as Xr, N as Xs, aa as Xt, Sn as Y, x as Ya, Qo as Yc, E as Yi, Cs as Yn, Ft as Yo, Vs as Yr, Ji as Ys, ia as Yt, da as Z, we as Za, es as Zc, Yr as Zi, ys as Zn, an as Zo, zs as Zr, Zi as Zs, oa as Zt, Pm as _, ze as _a, Xn as _c, Ns as _i, tc as _n, Br as _o, _c as _r, Lt as _s, S as _t, $m as a, ji as aa, ma as ac, ds as ai, Za as al, Pr as an, Ae as ao, Ls as ar, Qt as as, Va as at, Bm as b, Fe as ba, Yn as bc, Wo as bi, Is as bn, Vr as bo, ls as br, Pt as bs, fr as bt, qm as c, Ti as ca, ba as cc, Ds as ci, Bi as cl, br as cn, $r as co, Gs as cr, xt as cs, Si as ct, Dm as d, Ua as da, Ea as dc, yc as di, p as dl, Sr as dn, Go as do, Ys as dr, on as ds, ro as dt, Ii as ea, ta as ec, $s as ei, rs as el, ea as en, h as eo, Qs as er, rn as es, Fn as et, Tm as f, Be as fa, Ta as fc, bc as fi, f as fl, so as fn, Ko as fo, Xs as fr, xn as fs, io as ft, Am as g, fa as ga, Nn as gc, _s as gi, fo as gn, zr as go, wc as gr, un as gs, _n as gt, Om as h, Re as ha, Ia as hc, oc as hi, uo as hn, gc as ho, Cc as hr, bt as hs, qn as ht, Nm as i, Ci as ia, ra as ic, Ws as ii, $a as il, zn as in, it as io, Es as ir, Dt as is, Ha as it, Mm as j, ka as ja, In as jc, gi as ji, fc as jn, mr as jo, ss as jr, gn as js, _e as jt, Qm as k, _ as ka, w as kc, j as ki, cc as kn, Ir as ko, Io as kr, vt as ks, Tn as kt, Ym as l, Mi as la, xa as lc, Os as li, Vi as ll, cr as ln, Qa as lo, Ks as lr, Ot as ls, vi as lt, Wm as m, Ue as ma, La as mc, ac as mi, lo as mn, hc as mo, Js as mr, Xt as ms, oo as mt, th as n, Li as na, pa as nc, hs as ni, eo as nl, An as nn, b as no, ic as nr, $t as ns, Ba as nt, Km as o, Ei as oa, ga as oc, js as oi, Ui as ol, ve as on, ki as oo, Rs as or, Mt as os, mi as ot, Vm as p, y as pa, Fa as pc, Uo as pi, co as pn, qo as po, qs as pr, En as ps, ao as pt, ut as q, nt as qa, Xo as qc, qr as qi, xs as qn, tn as qo, ps as qr, qi as qs, _a as qt, Um as r, Oi as ra, sa as rc, Us as ri, us as rl, ur as rn, at as ro, Ts as rr, en as rs, za as rt, Jm as s, Ai as sa, ya as sc, Ms as si, Hi as sl, Rn as sn, ni as so, ks as sr, Nt as ss, ai as st, nh as t, Pi as ta, na as tc, ec as ti, as as tl, jn as tn, g as to, rc as tr, Ct as ts, Mn as tt, Em as u, Di as ua, Pa as uc, vs as ui, zi as ul, be as un, Xa as uo, As as ur, m as us, no as ut, Rm as v, Ra as va, Gn as vc, Ps as vi, nc as vn, He as vo, vc as vr, pt as vs, dr as vt, Im as w, Le as wa, kn as wc, xi as wi, mo as wn, C as wo, jo as wr, It as ws, Jn as wt, Zm as x, Ie as xa, Hn as xc, qa as xi, xc as xn, Vn as xo, Oo as xr, wt as xs, er as xt, zm as y, Wa as ya, Wn as yc, fs as yi, Fs as yn, Hr as yo, Do as yr, cn as ys, lr as yt, Vt as z, wa as za, kr as zc, di as zi, mc as zn, et as zo, pn as zr, hn as zs, yr as zt };
